import { Component, Inject, ElementRef ,ViewChild } from '@angular/core';
import {ObservablesService} from './observables.service';
import {ApiService} from './api.service';
import {PrintService} from './print.service';
import {Router} from '@angular/router';
import { Subject } from "rxjs";
import { _ } from 'underscore';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import * as jspdf from 'jspdf';
import html2canvas from 'html2canvas';

export interface DialogData {
  action:boolean;
  message:any;
  data:any;
}

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'PaymentBook';
  messageColor:any
  toastMessage:string = ''
  messageStatus:boolean = false;
  slipPrintSubscriber:any;
  invoiceViewSubscriber:any;
  constructor(public dialog: MatDialog,private router:Router, private observables:ObservablesService,private api:ApiService){
    if(localStorage.getItem('superAdminLoggedInStatus') =='1' && localStorage.getItem('adminLoggedInStatus') == '0' && localStorage.getItem('userLoggedInStatus') == '0'){
      this.checkLoggedStatus('super-admin')
    }else if(localStorage.getItem('adminLoggedInStatus') =='1' && localStorage.getItem('superAdminLoggedInStatus') == '0' && localStorage.getItem('userLoggedInStatus') == '0'){
      this.checkLoggedStatus('admin')
    }else if(localStorage.getItem('userLoggedInStatus') =='1' && localStorage.getItem('superAdminLoggedInStatus') == '0' && localStorage.getItem('adminLoggedInStatus') == '0'){

      this.checkLoggedStatus('user')
    }else{
      localStorage.setItem("logOutStatus",'1')
      this.router.navigate(['/login']);
    }

    this.observables.toastMessageStatus.subscribe((data:any)=>{
      this.messageColor = data.type;
      this.toastMessage = data.message;
      this.messageStatus = true;
      setTimeout(()=>{ this.messageStatus = false }, 3000);
    })

    this.slipPrintSubscriber = this.observables.showSlipViewStatus.subscribe((res:any)=>{
      this.openDialog(res)
    })


    this.invoiceViewSubscriber = this.observables.invoiceViewStatus.subscribe((res:any)=>{

      this.openInvoiceDialog(res)

    })

  }

  openDialog(data) {
    let dialogConfig:any;
    // console.log("popup data=",data)
      dialogConfig = {
        panelClass: 'popup',
        width: 'auto',
        data: {action:true,data:data,message:"Slip Data"}
      }

   const dialogRef = this.dialog.open(SlipPopupComponent,dialogConfig);

   dialogRef.afterClosed().subscribe(result => {
     // console.log(`Dialog result: ${result}`);

   });
 }
  openInvoiceDialog(data) {
    let dialogConfig:any;
    // console.log("popup data=",data)
      dialogConfig = {
        panelClass: 'invoicePopup',
        width: '60vw',
        data: {action:true,data:data,message:"Invoice With Slip Data"}
      }

   const dialogRef = this.dialog.open(InvoicePopupComponent,dialogConfig);

   dialogRef.afterClosed().subscribe(result => {
     // console.log(`Dialog result: ${result}`);

   });
 }

  checkLoggedStatus(role){
    console.log(role)
    if(role == 'super-admin'){
      if(localStorage.getItem('userId') !== null && localStorage.getItem('roleId') !== null && localStorage.getItem('businessId') == '' && localStorage.getItem('parentId') == ''){
        this.api.send("findDb",{
          table:"users as U",
          fields:['U.id','U.full_name','U.role_id','R.level','U.active_status'],
          joins:[{
            type:'left',
            table:'roles as R',
            conditions:["R.id = U.role_id"]
          }],
          conditions:[{
            "U.id":localStorage.getItem("userId"),
            "U.role_id":localStorage.getItem("roleId")
          }]
        }).then((userRes:any)=>{
          if(userRes.data.length > 0){

            if(userRes.data[0].active_status == 1 && !userRes.data[0].level){

                this.router.navigate(['/super-admin-dashboard']);
            }else{
                localStorage.clear();
                localStorage.setItem("logOutStatus",'1')
                this.router.navigate(['/login']);
              }
          }else{
            localStorage.clear();
            localStorage.setItem("logOutStatus",'1')
            this.router.navigate(['/login']);
          }
        })
      }
    }else if(role == 'admin'){
      if(localStorage.getItem('userId') !== null && localStorage.getItem('roleId') !== null && localStorage.getItem('businessId') !== null && localStorage.getItem('parentId') == ''){
        this.api.send("findDb",{
          table:"users as U",
          fields:['U.id','U.business_id','U.parent_id','U.full_name','U.role_id','R.level','U.active_status'],
          joins:[{
            type:'left',
            table:'roles as R',
            conditions:["R.id = U.role_id"]
          }],
          conditions:[{
            "U.id":localStorage.getItem("userId"),
            "U.business_id":localStorage.getItem("businessId"),
            "U.role_id":localStorage.getItem("roleId")
          }]
        }).then((userRes:any)=>{
          if(userRes.data.length > 0){

            if(userRes.data[0].active_status == 1 && userRes.data[0].level == 1){

                this.router.navigate(['/admin/dashboard']);
            }else{
                localStorage.clear();
                localStorage.setItem("logOutStatus",'1')
                this.router.navigate(['/login']);
              }
          }else{
            localStorage.clear();
            localStorage.setItem("logOutStatus",'1')
            this.router.navigate(['/login']);
          }
        })
      }
    }else if(role == 'user'){
      if(localStorage.getItem('userId') !== null && localStorage.getItem('roleId') !== null && localStorage.getItem('businessId') !== null && localStorage.getItem('parentId') !== null){
        this.api.send("findDb",{
          table:"users as U",
          fields:['U.id','U.business_id','U.parent_id','U.full_name','U.role_id','R.level','U.active_status'],
          joins:[{
            type:'left',
            table:'roles as R',
            conditions:["R.id = U.role_id"]
          }],
          conditions:[{
            "U.id":localStorage.getItem("userId"),
            "U.business_id":localStorage.getItem("businessId"),
            "U.role_id":localStorage.getItem("roleId")
          }]
        }).then((userRes:any)=>{
          if(userRes.data.length > 0){

            if(userRes.data[0].active_status == 1 && userRes.data[0].level > 1){

                this.router.navigate(['/user/dashboard']);
            }else{
                localStorage.clear();
                localStorage.setItem("logOutStatus",'1')
                this.router.navigate(['/login']);
            }
          }else{
            localStorage.clear();
            localStorage.setItem("logOutStatus",'1')
            this.router.navigate(['/login']);
          }
        })
      }
    }else{
      localStorage.setItem("logOutStatus",'1')
      this.router.navigate(['/login']);
    }
  }
}



@Component({
  selector: 'app-popup',
  templateUrl: './slip-popup/slip-popup.component.html',
  host: {'(window:keydown)': 'hotkeys($event)'}
})
export class SlipPopupComponent {
  hotkeys(event){
    if(event.ctrlKey && event.keyCode == 80) {
           event.preventDefault();
           this.onPrintSlip()
     }
  }
  constructor(private observables:ObservablesService,private print:PrintService,private api:ApiService,public dialog: MatDialog,public dialogRef: MatDialogRef<SlipPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData) {}
    message:any='';
    title:any='';
    subtitle:any='';
    subMessage:any='';
    mainData:any;
    action:boolean;
    slipData:any= [];
    itemData:any= [];
    rows:number = 10;
    gstAmount:number = 0;
    totalAmt:number = 0;
    totalWeight:number = 0;
    variable:number = 0;
    productSubscribeVariable:any;
    productObserver:any = new Subject<any>();
    variableSubscribeVariable:any;
    variableObserver:any = new Subject<any>();
    loggedUserInfo:any;
    preferences:any=[]

    public captureScreen()
    {
      var data = document.getElementById('contentToConvert');
      html2canvas(data).then(canvas => {
        // Few necessary setting options
        var imgWidth = 208;
        var pageHeight = 295;
        var imgHeight = canvas.height * imgWidth / canvas.width;
        var heightLeft = imgHeight;

        const contentDataURL = canvas.toDataURL('image/png')
        let pdf = new jspdf('p', 'mm', 'a4'); // A4 size page of PDF

        var position = 0;
        pdf.addImage(contentDataURL, 'PNG', 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;

         while (heightLeft >= 0) {
           position = heightLeft - imgHeight;
           pdf.addPage();
           pdf.addImage(contentDataURL, 'PNG', 0, position, imgWidth, imgHeight);
           heightLeft -= pageHeight;
         }
        pdf.save('slip_'+this.slipData.slip_number+'.pdf'); // Generated PDF
      });
    }

    ngOnInit() {
      // console.log("data in slip dialog=",this.data.data)

      this.mainData = this.data.data;

      this.api.getLoggedUserInfo().then((res:any)=>{
        // console.log('logged user info=',res)
        if(res.data.length > 0){
          this.loggedUserInfo = res.data[0];
          this.getPreferences()
        }else{
          this.api.logOut()
        }
      })
      this.getSlipDetails(this.mainData.id)
    }

    getPreferences(){
      this.api.send("findDb",{
        table:"preferences",
        conditions:[{"business_id":this.loggedUserInfo.business_id}]
      }).then((res:any)=>{
        if(res.data.length > 0){
          this.preferences = res.data[0]
          // console.log("preferences==",this.preferences)
        }else{
          //create a preference
          this.setPreferences(this.loggedUserInfo.business_id)
        }
      })
    }

    getTotalUnit(variables){
      // console.log("asdasd=",variables)
      if(variables !== undefined){

        return variables.reduce( ( accumulator, currentValue ) => {
          return accumulator * parseFloat(currentValue.unit_variable_value);
        }, 1);
      }
    }


    getSlipDetails(slip_id){
      return new Promise((resolve)=>{

        this.api.send("findDb",{
          fields:["S.*,P.*,S.id as master_slip_id,S.party_name as business_name, P.business_name as customer_business_name"],
          table:"master_slips as S",
          joins:[{
            type:"left",
            table:"parties as P",
            conditions:["P.id = S.party_id"]
          }],
          conditions:[{
            "S.id" :slip_id
          }]
        }).then((result:any)=>{
          // console.log("result=",result)

          if(result.data.length > 0){

            this.slipData = result.data[0];
            // console.log("this.slipdata==",this.slipData)
            if(this.slipData.direct_slip_status){
              this.totalAmt = this.totalAmt + this.slipData.total_amount
              resolve(true)
            }else{

              this.api.send("findDb",{
                table:"categories",
                conditions:[{slip_id:this.slipData.slip_id}]
              }).then((result1:any)=>{
                console.log("category == ",result1.data)

                this.getData(result1.data).then((res:any)=>{

                  // console.log("final data = ",res)

                  this.itemData = res;
                  // this.getWeightTotal()
                  this.getGstAmount().then(()=>{
                    resolve(true)
                  })
                  // //this.getTotalAmt()
                })

              })
            }
          }else{
            resolve(true)
          }
        })
      })
    }

    getData(data){
      return new Promise((resolve)=>{
        let a = 0
        let number = 0
        this.productSubscribeVariable = this.productObserver.subscribe((a)=>{
          if(a>=data.length){
            this.productSubscribeVariable.unsubscribe();
            resolve(data)
          }else{
            if(data[a].hasOwnProperty('category_name')){

              this.api.send("findDb",{
                table:"master_slip_products as PD",
                conditions:[{
                  "PD.master_slip_id" :this.slipData.master_slip_id,
                  "PD.category_id":data[a].id
                }],
                order:"PD.id ASC"
              }).then((result2:any)=>{
                // console.log("product data=",result2.data)
                if(result2.data.length > 0){
                  this.prepareData(result2.data,a,data,number).then((resp:any)=>{
                    data=resp.data;
                    number=resp.number
                    this.productObserver.next(a+1);
                  })

                }else{
                  this.productObserver.next(a+1);
                }
              })
            }else{
              this.productObserver.next(a+1);
            }

          }
        })

        this.productObserver.next(a);
      })
    }

    prepareData(item,index,data,number){
      return new Promise((resolve)=>{
        let a = 1
        this.variableSubscribeVariable = this.variableObserver.subscribe((a)=>{
          if(a>item.length){
            this.variableSubscribeVariable.unsubscribe();
            resolve({data:data,number:number})
          }else{
            number = number + 1;
            data.splice(index+a, 0, item[a-1]);
            data[index+a].number = number;
            // data[index+a].unit_variables = []
            this.variableObserver.next(a+1);
              // this.getProductUnitVariables(item[a-1]).then((itemRes:any)=>{
              //   data[index+a].unit_variables = itemRes
              //
              // })
          }

        })

        this.variableObserver.next(a);
      })
    }

    getProductUnitVariables(item){
      return new Promise((resolve)=>{
        this.api.send("findDb",{
          table:"product_unit_variables as PU",
          joins:[{
            type:"left",
            table:"unit_variables as UV",
            conditions:["UV.id = PU.unit_variable_id"]
          }],
          conditions:[{"PU.product_detail_id":item.product_detail_id}]
        }).then((res:any)=>{
          // console.log("product_unit_variables=",res)
          if(res.data.length > 0){

            resolve(res.data)
          }
        })
      })
    }

    async getGstAmount(){

      await this.itemData.filter((item:any)=>{
        if(!item.hasOwnProperty('slip_id')){

          this.gstAmount=this.gstAmount + ((item.gross_amount*item.gst)/100);
          this.totalAmt=this.totalAmt + item.gross_amount;
        }
      })

    }

    onPrintSlip(){
      // console.log("slip data==",this.slipData)
      const slipIds = [this.slipData.master_slip_id];
      this.print.printDocument('slip', slipIds);
    }

    setPreferences(business_id){
      return new Promise((resolve)=>{
        let data = {
          business_id:business_id,
          invoice_title:'INVOICE',
          slip_title:'DELIVERY CHALLAN',
          item_name:"Particulars",
          unit_variable_1:"Column1",
          unit_variable_1_status:1,
          unit_variable_2:"Column2",
          unit_variable_2_status:1,
          unit_variable_3:"Column3",
          unit_variable_3_status:1,
          unit:"Quantity",
          unit_status:1,
          tax:"GST",
          tax_status:1,
          unit_price:"Rate",
          unit_price_status:1,
        }

        this.api.send("insertDb",{
          table:"preferences",
          data:data
        }).then((res:any)=>{

          if(res.data.affectedRows){
            this.observables.showToastMessage({type:0, message:"Preferences Saved"})
            this.preferences = data;
            resolve(true)
          }else{
            resolve(true)
            this.observables.showToastMessage({type:1, message:"Preferences Not Saved"})

          }
        })
      })
    }

}

@Component({
  selector: 'app-invoice-popup',
  templateUrl: './invoice-popup/invoice-popup.component.html',
  host: {'(window:keydown)': 'hotkeys($event)'}

})
export class InvoicePopupComponent {
  hotkeys(event){
    if(event.ctrlKey && event.keyCode == 80) {
           event.preventDefault();
           this.onPrintInvoice()
     }
  }
  constructor(private observables:ObservablesService,private print:PrintService, private api:ApiService,public dialog: MatDialog,public dialogRef: MatDialogRef<InvoicePopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData) {}
    message:any='';
    title:any='';
    subtitle:any='';
    subMessage:any='';
    mainData:any;
    action:boolean;
    invoiceData:any= [];
    itemData:any= [];
    rows:number = 10;
    gstAmount:number = 0;
    totalAmt:number = 0;
    totalWeight:number = 0;
    variable:number = 0;
    productSubscribeVariable:any;
    productObserver:any = new Subject<any>();
    slipSubscribeVariable:any;
    slipObserver:any = new Subject<any>();
    slipData:any= [];
    variableSubscribeVariable:any;
    variableObserver:any = new Subject<any>();
    loggedUserInfo:any;
    sameStateStatus:boolean = true;
    preferences:any=[]
    direct_invoice_items:any=[]
    direct_slip_items:any=[]

    public captureScreen()
    {
      var data = document.getElementById('contentToConvert');
      html2canvas(data).then(canvas => {
        // Few necessary setting options
        var imgWidth = 208;
        var pageHeight = 295;
        var imgHeight = canvas.height * imgWidth / canvas.width;
        var heightLeft = imgHeight;

        const contentDataURL = canvas.toDataURL('image/png')
        let pdf = new jspdf('p', 'mm', 'a4'); // A4 size page of PDF

        var position = 0;
        pdf.addImage(contentDataURL, 'PNG', 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;

         while (heightLeft >= 0) {
           position = heightLeft - imgHeight;
           pdf.addPage();
           pdf.addImage(contentDataURL, 'PNG', 0, position, imgWidth, imgHeight);
           heightLeft -= pageHeight;
         }
        pdf.save('invoice_'+this.invoiceData.invoice_number+'.pdf'); // Generated PDF

      });
    }


    ngOnInit() {

      this.invoiceData = this.data.data.invoiceData;

      // console.log("data in invoice dialog=",this.invoiceData)

      this.api.getLoggedUserInfo().then((res:any)=>{
        // console.log('logged user info=',res)
        if(res.data.length > 0){
          this.loggedUserInfo = res.data[0];
          this.checkState();
          this.getPreferences()
        }else{
          this.api.logOut()
        }
      })

      if(this.invoiceData.direct_invoice_status){

          this.totalAmt =this.totalAmt + this.invoiceData.total_amount;
            if(this.invoiceData.slip_status){
              this.direct_invoice_items= []
              this.getSlipDetails(this.invoiceData.id)
            }else{
              this.direct_slip_items = []
              this.direct_invoice_items.push(this.invoiceData)
            }
      }else{

        if(this.invoiceData.slip_status){

          this.getSlipDetails(this.invoiceData.id)
        }else{

          this.getCategoriess()
        }
      }
    }

    getPreferences(){
      this.api.send("findDb",{
        table:"preferences",
        conditions:[{"business_id":this.loggedUserInfo.business_id}]
      }).then((res:any)=>{
        if(res.data.length > 0){
          this.preferences = res.data[0]
          // console.log("preferences==",this.preferences)
        }else{
          //create a preference
          this.setPreferences(this.loggedUserInfo.business_id)
        }
      })
    }

    checkState(){
      if(this.invoiceData.gstin.length > 0){
        // console.log("1",this.invoiceData);
        // console.log("2",this.invoiceData);
        if(this.loggedUserInfo.gstin.substring(0,2) == this.invoiceData.gstin.substring(0,2)){
          this.sameStateStatus = true;
        }else{
          this.sameStateStatus = false;
        }
      }else{
        this.sameStateStatus = true;
      }
    }

    getTotalUnit(variables){
      // console.log("asdasd=",variables)
      if(variables !== undefined){

        return variables.reduce( ( accumulator, currentValue ) => {
          return accumulator * parseFloat(currentValue.unit_variable_value);
        }, 1);
      }
    }

    round(value, precision) {
      var multiplier = Math.pow(10, precision || 0);
      return Math.round(value * multiplier) / multiplier;
    }


    getSlipDetails(invoice_id){
      this.direct_slip_items =[]
      this.api.send("findDb",{
        fields:["S.*,P.*,S.id as master_slip_id,S.party_name as business_name"],
        table:"master_slips as S",
        joins:[{
          type:"left",
          table:"parties as P",
          conditions:["P.id = S.party_id"]
        }],
        conditions:[{
          "S.master_invoice_id" :invoice_id
        }]
      }).then((result:any)=>{
        if(result.data.length > 0){

          this.slipData = result.data;

          // console.log("this.slipdata==",this.slipData)
            if(!this.invoiceData.direct_invoice_status){
             this.getCategories(true)
           }else{
             this.direct_slip_items = this.slipData
           }
         }
      })
    }

    getCategories(slipStatus){
      return new Promise((resolve)=>{
        let a = 0
        let number = 0
        // console.log("slipDatass== ",this.slipData)
        this.slipSubscribeVariable = this.slipObserver.subscribe((a)=>{
          if(a>=this.slipData.length){
            this.slipSubscribeVariable.unsubscribe();
            this.getGstAmount().then(()=>{

              resolve(this.slipData)
            })
          }else{
            let conditions:any = (slipStatus)?{slip_id:this.slipData[a].slip_id}:{invoice_id:this.invoiceData.id}
            this.api.send("findDb",{
              table:"categories",
              conditions:[conditions]
            }).then((result1:any)=>{
              // console.log("category == ",result1.data)

              this.getData(result1.data, a).then((res:any)=>{

                // console.log("final data = ",res)
                this.processData(res).then((resp)=>{

                  // console.log("final datasa = ",resp)
                  this.slipObserver.next(a+1);
                })
                // this.getWeightTotal()

                // //this.getTotalAmt()
              })

            })


          }
        })

        this.slipObserver.next(a);
      })
    }

    processData(res){
      return new Promise((resolve)=>{

        for(let i=0;i<res.length;i++){

          this.itemData.push(res[i]);

          if(i == res.length - 1){

            resolve(true)
          }
        }
      })
    }

 
    getCategoriess(){
      // console.log("this.invoiceData=",this.invoiceData)
      this.api.send("findDb",{
        table:"categories",
        conditions:[{invoice_id:this.invoiceData.invoice_id}]
      }).then((result1:any)=>{
        // console.log("category == ",result1.data)
        this.getInvoiceData(result1.data).then((res:any)=>{

          // console.log("final data = ",res)
          this.itemData = res;
          // this.getWeightTotal()
          this.getGstAmount()
          // //this.getTotalAmt()
        })

      })
    }

    getData(data,index){
      return new Promise((resolve)=>{
        let a = 0
        let number = 0
        this.productSubscribeVariable = this.productObserver.subscribe((a)=>{
          // console.log("abcd==",this.slipData)
          // console.log("data.length=",data.length)
          // console.log("aaaa=",a)
          if(a>=data.length){
            this.productSubscribeVariable.unsubscribe();
            resolve(data)
          }else{
            if(data[a].hasOwnProperty('category_name')){
              this.api.send("findDb",{
                table:"master_slip_products as PD",
                conditions:[{
                  "PD.master_slip_id" :this.slipData[index].master_slip_id,
                  "PD.category_id":data[a].id
                }],
                order:"PD.id ASC"
              }).then((result2:any)=>{
                // console.log("product data=",result2.data)

                if(result2.data.length > 0){
                  this.prepareData(result2.data,a,data,number).then((resp:any)=>{
                    data=resp.data;
                    number=resp.number
                    this.productObserver.next(a+1);
                  })

                }else{
                  this.productObserver.next(a+1);
                }
              })
            }else{
              this.productObserver.next(a+1);
            }

          }
        })

        this.productObserver.next(a);
      })
    }
    getInvoiceData(data){
      // console.log("abcd==",data)
      return new Promise((resolve)=>{
        let a = 0
        let number = 0
        this.productSubscribeVariable = this.productObserver.subscribe((a)=>{
          if(a>=data.length){
            this.productSubscribeVariable.unsubscribe();
            resolve(data)
          }else{
            if(data[a].hasOwnProperty('category_name')){
              this.api.send("findDb",{
                table:"master_invoice_products as PD",
                joins:[{
                  type:"left",
                  table:"product_details as P",
                  conditions:["P.id = PD.product_detail_id"]
                }],
                conditions:[{
                  "PD.master_invoice_id" :this.invoiceData.id,
                  "PD.category_id":data[a].id
                }],
                order:"PD.id ASC"
              }).then((result2:any)=>{
                // console.log("product datas=",result2.data)
                if(result2.data.length > 0){
                  this.prepareData(result2.data,a,data,number).then((resp:any)=>{
                    data=resp.data;
                    number=resp.number
                    this.productObserver.next(data.length+1);
                  })

                }else{
                  this.productObserver.next(a+1);
                }
              })
            }else{
              this.productObserver.next(a+1);
            }

          }
        })

        this.productObserver.next(a);
      })
    }

    prepareData(item,index,data,number){
      return new Promise((resolve)=>{
        let a = 1
        this.variableSubscribeVariable = this.variableObserver.subscribe((a)=>{
          if(a>item.length){
            this.variableSubscribeVariable.unsubscribe();
            resolve({data:data,number:number})
          }else{

            // console.log("data===",data)
            number = number + 1;
            data.splice(index+a, 0, item[a-1]);
            data[index+a].number = number;
            // console.log("data===",data)

            // data[index+a].unit_variables = []
              // this.getProductUnitVariables(item[a-1]).then((itemRes:any)=>{
              //   data[index+a].unit_variables = itemRes
                  this.variableObserver.next(a+1);

              // })
          }

        })

        this.variableObserver.next(a);
      })
    }

    // getData(data,slip_status){
    //   console.log("abcd==",data)
    //   return new Promise((resolve)=>{
    //     let a = 0
    //     let number = 0
    //     this.productSubscribeVariable = this.productObserver.subscribe((a)=>{
    //       if(a>=data.length){
    //         this.productSubscribeVariable.unsubscribe();
    //         resolve(data)
    //       }else{
    //         if(data[a].hasOwnProperty('category_name')){
    //
    //           let conditions:any = (slip_status)?{
    //             "PD.slip_id" :this.slipData.slip_id,
    //             "PD.category_id":data[a].id
    //           }:{
    //             "PD.invoice_id" :this.invoiceData.id,
    //             "PD.category_id":data[a].id
    //           }
    //
    //           this.api.send("findDb",{
    //             fields:["PD.rate as product_rate,PD.*,PD.id as product_detail_id,I.name as item_name,I.gst,U.name as unit_name"],
    //             table:"product_details as PD",
    //             joins:[{
    //               type:"left",
    //               table:"items as I",
    //               conditions:["I.id = PD.item_id"]
    //             },{
    //               type:"left",
    //               table:"units as U",
    //               conditions:["U.id = I.unit_id"]
    //             }],
    //             conditions:[conditions],
    //             order:"PD.id ASC"
    //           }).then((result2:any)=>{
    //             // console.log("product data=",result2.data)
    //             if(result2.data.length > 0){
    //               this.prepareData(result2.data,a,data,number).then((resp:any)=>{
    //                 data=resp.data;
    //                 number=resp.number
    //                 this.productObserver.next(a+1);
    //               })
    //
    //             }else{
    //               this.productObserver.next(a+1);
    //             }
    //           })
    //         }else{
    //           this.productObserver.next(a+1);
    //         }
    //
    //       }
    //     })
    //
    //     this.productObserver.next(a);
    //   })
    // }

    getProductUnitVariables(item){
      return new Promise((resolve)=>{
        this.api.send("findDb",{
          table:"product_unit_variables as PU",
          joins:[{
            type:"left",
            table:"unit_variables as UV",
            conditions:["UV.id = PU.unit_variable_id"]
          }],
          conditions:[{"PU.product_detail_id":item.product_detail_id}]
        }).then((res:any)=>{
          if(res.data.length > 0){

            resolve(res.data)
          }
        })
      })
    }

    getTotalSqmt(item){
      return parseFloat(((item.col_1_value * item.col_2_value) * 0.000001).toFixed(2));
    }

    qtyLabelColspan(){
      let cols = 3;
      if(this.preferences.unit_variable_1_status) cols++;
      if(this.preferences.unit_variable_2_status) cols++;
      if(this.preferences.unit_variable_3_status) cols++;
      if(this.preferences.item_unit_col_name_status) cols++;
      return cols;
    }

    qtyTrailingColspan(){
      let cols = 1;
      if(this.preferences.unit_price_status) cols++;
      if(this.preferences.discount_status) cols++;
      if(this.preferences.tax_status) cols++;
      return cols;
    }

    getTotalQty() {
      return Number(
        this.itemData
          .reduce((acc: number, item: any) => {
            return acc + (parseFloat(item.qty) || 0);
          }, 0)
          .toFixed(2)
      );
    }


    getTotalSqmtTotal() {
      const total = Number(
        this.itemData
          .reduce((acc: number, item: any) => {
            const h = Number(item.col_1_value || 0);
            const w = Number(item.col_2_value || 0);
    
            return acc + (h * w * 0.000001);
          }, 0)
          .toFixed(2)
      );
    
      return total;
    }

    async getGstAmount(){

      await this.itemData.filter((item:any)=>{
        // console.log("item==",item)
        if(item.hasOwnProperty('item_id')){
          this.gstAmount=this.gstAmount + ((item.gross_amount*item.gst)/100);
          this.totalAmt=this.totalAmt + item.gross_amount;
        }
      })

    }

    public onPrintInvoice() {
      if(this.invoiceData.slip_status){

        // console.log("slip==",this.slipData)
        const invoiceIds = [this.slipData[0].master_invoice_id];
        this.print.printDocument('invoice', invoiceIds);
      }else{
        const invoiceIds = [this.invoiceData.id];
        this.print.printDocument('invoice', invoiceIds);
      }
    }

    setPreferences(business_id){
      return new Promise((resolve)=>{
        let data = {
          business_id:business_id,
          invoice_title:'INVOICE',
          slip_title:'DELIVERY CHALLAN',
          item_name:"Particulars",
          unit_variable_1:"Column1",
          unit_variable_1_status:1,
          unit_variable_2:"Column2",
          unit_variable_2_status:1,
          unit_variable_3:"Column3",
          unit_variable_3_status:1,
          unit:"Quantity",
          unit_status:1,
          tax:"GST",
          tax_status:1,
          unit_price:"Rate",
          unit_price_status:1,
        }

        this.api.send("insertDb",{
          table:"preferences",
          data:data
        }).then((res:any)=>{

          if(res.data.affectedRows){
            this.observables.showToastMessage({type:0, message:"Preferences Saved"})
            this.preferences = data;
            resolve(true)
          }else{
            resolve(true)
            this.observables.showToastMessage({type:1, message:"Preferences Not Saved"})

          }
        })
      })
    }


}
